import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { routing } from './app.routing';
import { AuthService } from './auth.service';
import { ToastrModule } from 'ngx-toastr';
import { ModalModule, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';
import { BootstrapModalModule, DialogService } from 'ng2-bootstrap-modal';
import { TokenInterceptor } from './token.interceptor';
import { SearchPipe, SearchByNamePipe } from './SearchPipe.pipe';
import { getimagepipe } from './Master/database/image.pipe';
import { HashLocationStrategy, LocationStrategy, DatePipe } from '@angular/common';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrderModule } from 'ngx-order-pipe';
import { AngularDraggableModule } from 'angular2-draggable';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { NgxSpinnerModule } from "ngx-spinner"; 


import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { UserComponent } from './Master/user/user.component';
import { MenurightsComponent } from './Shared/menurights/menurights.component';
import { LoginLayoutComponent } from './Shared/loginlayout/loginlayout.component';
import { HomeLayoutComponent } from './Shared/homelayout/homelayout.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { LogoutComponent } from './logout/logout.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { TopbarComponent } from './topbar/topbar.component';
import { DatabaseComponent } from './Master/database/database.component';
import { GovernmentComponent } from './Master/government/government.component';
import { OpiniontypeComponent } from './Master/opiniontype/opiniontype.component';
import { ProductComponent } from './Master/product/product.component';
import { PartComponent } from './Master/part/part.component';
import { StateComponent } from './Master/state/state.component';
import { CourtComponent } from './Master/court/court.component';
import { DepartmentComponent } from './Master/department/department.component';
import { BranchComponent } from './Master/branch/branch.component';
import { BusinessunitComponent } from './Master/businessunit/businessunit.component';
import { AgencyComponent } from './Master/agency/agency.component';
import { DocumenttitleComponent } from './Master/documenttitle/documenttitle.component';
import { DtdComponent } from './Master/dtd/dtd.component';
import { ConversiontypeComponent } from './Master/conversiontype/conversiontype.component';
import { CommondialogComponent } from './Shared/commondialog/commondialog.component';
import { MastermgtComponent } from './Master/mastermgt/mastermgt.component';
import { DocumenttypeComponent } from './Master/documenttype/documenttype.component';
import { MailfieldsComponent } from './Master/mailfields/mailfields.component';
import { MailtemplateComponent } from './Template/mailtemplate/mailtemplate.component';
import { MailgroupComponent } from './mailgroup/mailgroup.component';
import { AccessrequestComponent } from './accessrequest/accessrequest.component';
import { TeammgtComponent } from './teammgt/teammgt.component';
import { AccessrightsadminComponent } from './accessrightsadmin/accessrightsadmin.component';
import { UsermgtComponent } from './usermgt/usermgt.component';
import { UseraddComponent } from './Master/useradd/useradd.component';
import { HelpdeskComponent } from './Shared/helpdesk/helpdesk.component';
import { DatabasemgmtComponent } from './databasemgmt/databasemgmt.component';
import { FormconfigComponent } from './configuration/formconfig/formconfig.component';
import { FormtemplateComponent } from './Template/formtemplate/formtemplate.component';
import { FbeditorComponent } from './Shared/fbeditor/fbeditor.component';
import { RequestconfigComponent } from './configuration/requestconfig/requestconfig.component';
import { OutputformatComponent } from './Master/outputformat/outputformat.component';
import { MailconfigComponent } from './configuration/mailconfig/mailconfig.component';
import { ReleasenotesComponent } from './Shared/releasenotes/releasenotes.component';
import { FormrenderComponent } from './formrender/formrender.component';
import { AllocationComponent } from './Master/allocation/allocation.component';
import { StatusinputComponent } from './Master/statusinput/statusinput.component';
import { RequestdashboardComponent } from './dashboard/requestdashboard/requestdashboard.component';
import { CostcenterComponent } from './Master/costcenter/costcenter.component';
import { ProductgroupComponent } from './Master/productgroup/productgroup.component';
import { TypeComponent } from './Master/type/type.component';
import { FormdashboardComponent } from './dashboard/formdashboard/formdashboard.component';
import { QuerycommentsComponent } from './Shared/querycomments/querycomments.component';
import { RequestactivitylogComponent } from './request/requestactivitylog/requestactivitylog.component';
import { ContextMenuModule } from 'ngx-contextmenu';
import { ChildboxComponent } from './Shared/querycomments/childbox/childbox.component';
import { DatacontainerDirective } from './Shared/querycomments/querycomments.component';
import { QuerycommentsmgtComponent } from './querycommentsmgt/querycommentsmgt.component';
import { RecentactivitiesdashboardComponent } from './dashboard/recentactivitiesdashboard/recentactivitiesdashboard.component';
import { DocumentactivitylogComponent } from './Shared/documentactivitylog/documentactivitylog.component';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TreeviewModule } from 'ngx-treeview';
import { ProductdetailsComponent } from './configuration/requestconfig/productdetails/productdetails.component';
import { productDatacontainerDirective } from './configuration/requestconfig/requestconfig.component';

import { ArbitrationComponent } from './arbitration/arbitration.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ViewarbitrationComponent } from './arbitration/viewarbitration/viewarbitration.component';
import { ActivitylogComponent } from './activitylog/activitylog.component';
import { NewsletterComponent } from './Shared/newsletter/newsletter.component';
import { FiledownloadComponent } from './Shared/filedownload/filedownload.component';
import { FormdashboardgrouptableComponent } from './Shared/formdashboardgrouptable/formdashboardgrouptable.component';
import { DocumenttypegeneraluseComponent } from './Master/documenttypegeneraluse/documenttypegeneraluse.component';
import { DocumenttypeinternalrevenuebulletinsComponent } from './Master/documenttypeinternalrevenuebulletins/documenttypeinternalrevenuebulletins.component';
import { DocumenttypefederalregisteritemsComponent } from './Master/documenttypefederalregisteritems/documenttypefederalregisteritems.component';
import { DocumenttypeletterrullingComponent } from './Master/documenttypeletterrulling/documenttypeletterrulling.component';
import { DatabasearchiveComponent } from './databasearchive/databasearchive.component';
import { groupDatacontainerDirective } from './dashboard/formdashboard/formdashboard.component';
import { TooltipModule } from "ngx-tooltip";
import { navmenuservices } from './nav-menu/nav-menu.services';
import { CourtnameComponent } from './Master/courtname/courtname.component';
import { OpinionreviewComponent } from './Report/opinionreview/opinionreview.component';
import { ArchivedashboardComponent } from './dashboard/archivedashboard/archivedashboard.component';

import { BnNgIdleService } from 'bn-ng-idle'; // import bn-ng-idle service
import { PasswordstrengthComponent } from './Shared/passwordstrength/passwordstrength.component';
import { DialogwithtimerComponent } from './Shared/dialogwithtimer/dialogwithtimer.component';
import { PrehomepageComponent } from './prehomepage/prehomepage.component';
import { CbadashboardComponent } from    './dashboard/cbadashboard/cbadashboard.component';
//import {EventEmitterService} from './event-emitter.service';
import { NgTinyUrlModule,NgTinyUrlService } from "ng-tiny-url";
  
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    LoginComponent,
    UserComponent,
    LoginLayoutComponent,
    HomeLayoutComponent,
    ChangepasswordComponent,
    LogoutComponent,
    ResetpasswordComponent,
    TopbarComponent,
    DatabaseComponent,
    GovernmentComponent,
    OpiniontypeComponent,
    ProductComponent,
    PartComponent,
    StateComponent,
    CourtComponent,
    DepartmentComponent,
    BranchComponent,
    BusinessunitComponent,
    AgencyComponent,
    DocumenttitleComponent,
    DtdComponent,
    ConversiontypeComponent,
    CommondialogComponent,
    MastermgtComponent,
    DocumenttypeComponent,
    SearchPipe,
    SearchByNamePipe,
    TopbarComponent,
    getimagepipe,
    MailfieldsComponent,
    MailtemplateComponent,
    MailgroupComponent,
    AccessrequestComponent,
    TeammgtComponent,
    AccessrightsadminComponent,
    UsermgtComponent,
    UseraddComponent,
    HelpdeskComponent,
    MenurightsComponent,
    DatabasemgmtComponent,
    FormconfigComponent,
    FormtemplateComponent,
    FbeditorComponent,
    RequestconfigComponent,
    OutputformatComponent,
    MailconfigComponent,
    ReleasenotesComponent,
    FormrenderComponent,
    AllocationComponent,
    StatusinputComponent,
    RequestdashboardComponent,
    CostcenterComponent,
    ProductgroupComponent,
    TypeComponent,
    FormdashboardComponent,
    QuerycommentsComponent,
    ChildboxComponent,
    DatacontainerDirective,
    RequestactivitylogComponent,
    QuerycommentsmgtComponent,
    RecentactivitiesdashboardComponent,
    DocumentactivitylogComponent,
    ProductdetailsComponent,
    productDatacontainerDirective,
    ArbitrationComponent,
    ViewarbitrationComponent,
    ActivitylogComponent,
    NewsletterComponent,
    FiledownloadComponent,
    FormdashboardgrouptableComponent,
    DocumenttypegeneraluseComponent,
    DocumenttypeinternalrevenuebulletinsComponent,
    DocumenttypefederalregisteritemsComponent,
    DocumenttypeletterrullingComponent,
    DatabasearchiveComponent,
    groupDatacontainerDirective,
    CourtnameComponent,
    OpinionreviewComponent,
    ArchivedashboardComponent,
	PasswordstrengthComponent,
	DialogwithtimerComponent,
	PrehomepageComponent,
	CbadashboardComponent
  ],
  entryComponents: [CommondialogComponent, DialogwithtimerComponent,ChildboxComponent, ProductdetailsComponent, NewsletterComponent, FormdashboardgrouptableComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ModalModule.forRoot(),
    TimepickerModule.forRoot(),
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxPaginationModule,
    BootstrapModalModule.forRoot({ container: document.body }),
    TreeviewModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(), ContextMenuModule.forRoot(), BsDatepickerModule.forRoot(),
    NgbModule,
    OrderModule,
    AngularDraggableModule,
    NgxDatatableModule,
    PerfectScrollbarModule,
    AngularDualListBoxModule,
    NgxSpinnerModule,
    TooltipModule,
    routing,NgTinyUrlModule
  ],
  providers:
    [
      NgTinyUrlService,
      AuthService,
      BsModalService,
      MenurightsComponent,
      BsModalRef,
      DialogService,
      DatePipe,
      NavMenuComponent, navmenuservices,
      FbeditorComponent,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true
      },
      {
        provide: PERFECT_SCROLLBAR_CONFIG,
        useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
      }, { provide: LocationStrategy, useClass: HashLocationStrategy }
    ,BnNgIdleService // add it to the providers of your module
	,PasswordstrengthComponent
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
